import {
  VisitNoteTemplate,
  VisitNoteTemplateControllerApi,
} from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

interface Params {
  visitNoteTemplate: VisitNoteTemplate;
  xTENANTID?: string;
}

/**
 * @author [Rajkumar Rathod]
 */
export const useVisitNoteTemplateUpdate = () =>
  useMutationWithLoading(async (params: Params) =>
    new VisitNoteTemplateControllerApi(
      getConfigObject()
    ).updateVisitNoteTemplate(params?.visitNoteTemplate, params?.xTENANTID)
  );
